import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=0553c527&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=0553c527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553c527",
  null
  
)

export default component.exports